export const baseUrl = "https://hccapi.mobifone5.vn/cahphanquang"
//export const baseUrl = "http://localhost:6005"
//export const baseUrl = "https://api-bhtt.mobifone5.vn/api-bhtt"
//export const baseUrl = "https://apiungdunganm.haiduong.gov.vn/anm"
export default {
    baseUrl
}
